import { LayoutDashboard, BrainCircuit, Receipt, Cpu, Terminal, Sliders, FileText, MessageSquareText } from "lucide-react";

const LINKS = [
  { id: "overview", label: "Panoramica", icon: LayoutDashboard, testid: "nav-item-overview" },
  { id: "segnali", label: "Segnali & AI", icon: BrainCircuit, testid: "nav-item-segnali" },
  { id: "posizioni", label: "Posizioni Attive", icon: Receipt, testid: "nav-item-posizioni" },
  { id: "ai-opinion", label: "Chiedi all'AI", icon: MessageSquareText, testid: "nav-item-ai-opinion" },
  { id: "ai-consensus", label: "AI Consensus", icon: Cpu, testid: "nav-item-ai-consensus" },
  { id: "log-operazioni", label: "Log Operazioni", icon: Terminal, testid: "nav-item-log-operazioni" },
  { id: "impostazioni", label: "Impostazioni MT5", icon: Sliders, testid: "nav-item-impostazioni" },
  { id: "documentazione", label: "Documentazione", icon: FileText, testid: "nav-item-documentazione" },
];

export default LINKS;
